import { memo, type FC } from 'react';
import { useMediaQuery } from 'react-responsive';

import { Media } from '../../../../../theme/Media.tsx';
import Icons from '../../../../Elements/Icons/index.ts';
import { DropdownList as UIDropdownList } from '../../../DropdownList/index.tsx';
import { ActionButton } from '../ActionButton/index.tsx';
import type { DropdownListProps } from './types.ts';

export const DropdownList: FC<DropdownListProps> = memo(function DropdownList({
  zIndex = 10,
  buttonLabel = 'More',
  isLoading,
  buttonDataTestId,
  ...restProps
}) {
  const isMobile = useMediaQuery({ query: Media.xsMax });

  return (
    <UIDropdownList
      zIndex={zIndex}
      isLoading={isLoading}
      renderButton={(isShown) => (
        <ActionButton dataTestId={buttonDataTestId} disabled={restProps.disabled} isLoading={isLoading}>
          <Icons.More size={20} active={isShown} />
          {isMobile && buttonLabel}
        </ActionButton>
      )}
      {...restProps}
    />
  );
});
